export default "__VITE_ASSET__JddIFH34__"